import BaseView from "./_BaseView";
import Table from "../components/Table";
import Api from "../Api";
import Confirm from "../components/Confirm";

export default class OrganizationView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#organizationForm';
        this.formUrl = '/api/organizations';
        this.formTpl = 'organization-form';
        this.formTitle = Lang.orginfo;
        this.modalClasses = 'larger-modal';
        this.defaultObject = {
            name: '',
            match: '',
        };
        this.formCallback = function () {
            this.table.reload();
            // clear cache
            // get a new form next time because the instances could have changed
            delete Api.templates['organization-form'];
        };
    }

    init() {
        super.init();

        const orgs = $('#organizations');
        if (orgs.length > 0) {
            const id = $('[data-org]').data('org');
            const columns = [
                {data: 'name', orderable: true},
                {data: 'applications', orderable: false},
                {data: 'deactivated', orderable: false},
                {data: 'tools', orderable: false},
            ];

            if (!orgs.hasClass('hide-trial')) {
                // add instance column
                columns.splice(2, 0, {data: 'trial'});
            }

            if (!orgs.hasClass('hide-instance')) {
                // add instance column
                columns.splice(2, 0, {data: 'instance', orderable: false});
            }

            this.table = new Table('organizations', '/api/organizations/table?app=' + id, columns);
        }
    }

    getFormData() {
        const data = super.getFormData();
        data.active = !!(data.active);
        data.allowCreate = !!(data.allowCreate);
        data.whitelabel = !!(data.whitelabel);
        data.allowConfig = !!(data.allowConfig);
        data.consented = !!(data.consented);
        data.allowBeta = !!(data.allowBeta);
        data.newUI = !!(data.newUI);
        if (data.type !== 'trial') {
            data.trial_term_id = null;
        }
        return data;
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const container = $('#organizations');
        const body = $('body');

        $('.add-organization').on('click', function () {
            self.renderForm();
            return false;
        });

        container.on('click', '.edit', function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/organizations/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        container.on('click', '.delete', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(0)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: `<strong>${Lang.delorg}</strong><br>
                    ${Lang.delsure}<br><br><strong class="msg-box danger">${Lang.delundone}</strong>`,
                onConfirm: function () {
                    Api.send(`/api/organizations/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });
            return false;
        });

        // deactivate
        container.on('click.appdeac', '.deactivate', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(0)').text();
            Confirm({
                ok: Lang.deactivate,
                title: name,
                msg: Lang.deactivateMsg,
                onConfirm: function () {
                    Api.send(`/api/organizations/${id}/deactivate`, {}, 'post').done(function () {
                        self.table.reload();
                    });
                }
            });
        });

        // reactivate
        container.on('click.appreac', '.reactivate', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(0)').text();
            Confirm({
                ok: Lang.reactivate,
                title: name,
                msg: Lang.ActivateMsg,
                onConfirm: function () {
                    Api.send(`/api/organizations/${id}/reactivate`, {}, 'post').done(function () {
                        self.table.reload();
                    });
                }
            });
        });

        body.on('click', '.new-instance', function () {
            $('.select-instance').hide().find('select').prop('disabled', true);
            $('.new-instance-field').show().find('input').prop('disabled', false);
            $('input[name="subdomain"]').addClass('aero-required');
            $('select[name="instance_id"]').removeClass('aero-required');
            return false;
        });

        body.on('click', '.cancel-instance', function () {
            $('.select-instance').show().find('select').prop('disabled', false);
            $('.new-instance-field').hide().find('input').prop('disabled', true);
            $('input[name="subdomain"]').removeClass('aero-required');
            $('select[name="instance_id"]').addClass('aero-required');
            return false;
        });

        body.on('click', '.edit-instance', function () {
            // hide select, but leave it enabled
            $('.select-instance').hide();
            $('.new-instance-field').show().find('input').prop('disabled', false);
            const inst = $.trim($('select[name="instance_id"] option:selected').text());
            $('input[name="subdomain"]').val(inst.split('.')[0]);
            return false;
        });

        body.on('change', '#organizationForm [name="type"]', function () {
            $('.trial-options').hide();
            if ($(this).val() === 'trial') {
                $('.trial-options').show();
            }
        });
    }
}
